import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    BottomNavigation,
    BottomNavigationAction,
    AppBar,
    CssBaseline,
    Snackbar,
    Grid,
} from '@material-ui/core';

import HomeIcon from '@material-ui/icons/Home';
import MovieOutlinedIcon from '@material-ui/icons/MovieOutlined';
import WhatshotOutlinedIcon from '@material-ui/icons/WhatshotOutlined';
import PersonIcon from '@material-ui/icons/Person';

import AppConfig from '../../control/config';
import AppUtils from '../../control/apputlis';
import DeviceEventEmitter, { EventName } from '../../control/event';
import FIMUtils from '../../im/FIMUtils';

import HomePage from '../home/Home';
import MinePage from '../mine/Mine';
import MatchPage from '../match/MatchPage';
import AnchorPage from '../anchor/AnchorPage';
import SubscribePage from '../subscribe/SubscribePage';
import ChatPage from '../chat/ChatPage';
import AppData from '../../model/AppData';
import Apis from '../../network/Apis';
import GoodFriendPage from '../goodfriend/GoodFriendPage'

import IMEventEmitter, { IMEvent } from '../../net/IMEventEmitter';
import IMApp from '../../net/IMApp';

const HOME_TAB_ICON_0 = require("../../images/icons/shouye.png");
const HOME_TAB_ICON_1 = require("../../images/icons/shouye1.png");

const MOVIE_TAB_ICON_0 = require("../../images/icons/saicheng.png");
const MOVIE_TAB_ICON_1 = require("../../images/icons/saicheng1.png");

const VIP_TAB_ICON_0 = require("../../images/icons/dingyue.png");
const VIP_TAB_ICON_1 = require("../../images/icons/dingyue1.png");

const MINE_TAB_ICON_0 = require("../../images/icons/wode.png");
const MINE_TAB_ICON_1 = require("../../images/icons/wode1.png");

const FX_TAB_ICON_0 = require("../../images/icons/zhibo.png");
const FX_TAB_ICON_1 = require("../../images/icons/zhibo1.png");

const MS_TAB_ICON_0 = require("../../images/icons/ic_tab_live_selected.png");
const MS_TAB_ICON_1 = require("../../images/icons/ic_tab_live.png");


var navItems = [
    { text: '首页', icon: <HomeIcon />, component: <HomePage />, activeIcon: HOME_TAB_ICON_0, inactiveIcon: HOME_TAB_ICON_1 },
    { text: '赛程', icon: <MovieOutlinedIcon />, component: <MatchPage />, activeIcon: MOVIE_TAB_ICON_0, inactiveIcon: MOVIE_TAB_ICON_1 },
    { text: '消息', icon: <WhatshotOutlinedIcon />, component: <ChatPage />, activeIcon: MS_TAB_ICON_0, inactiveIcon: MS_TAB_ICON_1 },
    { text: '好友', icon: <WhatshotOutlinedIcon />, component: <GoodFriendPage />, activeIcon: VIP_TAB_ICON_0, inactiveIcon: VIP_TAB_ICON_1 },
    { text: '我的', icon: <PersonIcon />, component: <MinePage />, activeIcon: MINE_TAB_ICON_0, inactiveIcon: MINE_TAB_ICON_1 },
];





const StyledBottomNavigationAction = withStyles((theme) => ({
    root: {
        marginTop: 3,
    },
    selected: {

    },
    label: {
        color: AppConfig.tabColor,
        fontSize: 9,
        marginTop: 8,
        '&$selected': {
            fontSize: 9,
            color: AppConfig.tabSelColor,
        }
    }
}))(BottomNavigationAction);


class MainPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogs: [],
            data: [],
            value: 0,
            tabs: navItems,
            snackopened: false,
            message: '',
            is_has_communication: 1,
            showPoint: false,
            showApply: false,
            isLoding: true
        };

        this.setValue = this.setValue.bind(this);
        this._showDialog = this._showDialog.bind(this);
        this._removeDialog = this._removeDialog.bind(this);
        this._onMainRouter = this._onMainRouter.bind(this);
        this._onWhereRouter = this._onWhereRouter.bind(this);
    }

    setValue(newValue) {
        const { value, is_has_communication } = this.state;



        if (is_has_communication != 1) {
            if (newValue == 3) {
                this.setState({ message: '暂未开放', snackopened: true });
                return;
            }
        }

        if (value === newValue && newValue === 0) {
            DeviceEventEmitter.emit(EventName.HOME_REFRESH, true);
        }
        this.setState({
            value: newValue,
        });
        AppUtils.setStorageItem(AppUtils.MAIN_PAGE_INDEX_KEY, newValue);
    }

    componentDidMount() {
        this.getServerConfig();
        DeviceEventEmitter.on(EventName.SHOW_DIALOG, this._showDialog, this);
        DeviceEventEmitter.on(EventName.REMOVE_DIALOG, this._removeDialog, this);
        DeviceEventEmitter.on(EventName.COMMENT_MAIN_ROUTER, this._onMainRouter, this);
        DeviceEventEmitter.on(EventName.COMMENT_MAIN_ROUTER_WHERE, this._onWhereRouter, this);
        IMEventEmitter.on(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
        IMEventEmitter.on(IMEvent.S2C_MSG_RED_NTY_APPLY_NUM, this.onShowPointEvent, this);

        AppUtils.YMPush('MAIN', '主界面');
        // if (!AppData.me.isLogin()) {
        //     AppData.login();
        //     AppData.heatBeat();
        //     AppData.getShareConfig();
        //     
        // }

    }

    componentWillUnmount() {
        this.setState = () => false;
        DeviceEventEmitter.off(EventName.SHOW_DIALOG, this._showDialog, this);
        DeviceEventEmitter.off(EventName.REMOVE_DIALOG, this._removeDialog, this);
        DeviceEventEmitter.off(EventName.COMMENT_MAIN_ROUTER, this._onMainRouter, this);
        DeviceEventEmitter.off(EventName.COMMENT_MAIN_ROUTER_WHERE, this._onWhereRouter, this);
        IMEventEmitter.off(EventName.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
        IMEventEmitter.off(IMEvent.S2C_MSG_RED_NTY_APPLY_NUM, this.onShowPointEvent, this);

    }

    onMessageReceived = async () => {

        let result = await FIMUtils.getConversationList();
        for (const key in result) {
            if (result[key].unreadCount > 0) {
                this.setState({ showPoint: true });
                return;
            }
        }


    }

    onShowPointEvent = () => {
        //检查是否有新的好友申请
        let list = IMApp.applylist
        let oldData = IMApp.getFriendList();


        let data = [];
        for (let i = 0; i < list.length; i++) {
            let exist = false;

            for (let j = 0; j < oldData.length; j++) {
                if (list[i].uid == oldData[j].uid) {
                    exist = true;
                }
            }

            if (!exist) {
                data.push(list[i]);
            }
        }
        //新的好友请求

        if (data.length === 0) {
            return
        }
        this.setState({ showApply: true });
    }

    getServerConfig = async () => {
        let offChat = false; //关闭所有聊天

        let res = await Apis.encryptionServerConfig();
        if (res.code == 200 && res.data) {
            offChat = res.data.all_chat == 2 ? true : false;
            AppData.ServerConfig = res.data
            // console.log(AppData.ServerConfig);
        }

        let _tabs = this.state.tabs;


        if (offChat) {
            _tabs.splice(2, 2);
        }
        this.setState({
            tabs: _tabs,
            isLoding: false
        })
    }

    _onWhereRouter(data) {
        this.setValue(data);
    }

    _onMainRouter(data) {
        this.setValue(1);
    }

    _showDialog(item) {
        console.log('_showDialog');
        const { dialogs } = this.state;
        dialogs.push(item);
        this.setState({
            dialogs: dialogs,
        });
    }

    _removeDialog(name) {
        const { dialogs } = this.state;
        for (let i = dialogs.length - 1; i >= 0; i--) {
            const item = dialogs[i];
            if (item.name === name) {
                dialogs.splice(i, 1);
            }
        }

        this.setState({
            dialogs: dialogs,
        });
    }
    // className='fotter'

    render() {
        const { classes } = this.props;
        let { value, dialogs, tabs, snackopened, message, showPoint, showApply, isLoding } = this.state;
        if (!isLoding) {
            return (
                <React.Fragment>
                    <CssBaseline />
                    <div className={classes.paperBottom}>
                        {tabs[value].component}
                    </div>
                    <AppBar position="fixed" color="primary"  style={{
                        top: 'auto',
                        bottom: 0,
                    }}>
                        <BottomNavigation
                            value={Number(value)}
                            onChange={(event, newValue) => {
                                this.setValue(newValue);
                            }}
                            showLabels
                        >
                            {
                                tabs.map((n, i) => (
                                    <StyledBottomNavigationAction
                                        key={i + ''}
                                        label={n.text}
                                        icon={
                                            <Grid container justifyContent='center' style={{ position: 'relative' }}>
                                                <img src={i === value ? n.activeIcon : n.inactiveIcon}
                                                    alt={n.text}
                                                    className={classes.tabIcon}
                                                />
                                                {showPoint && i == 2 && <div className={classes.point}></div>}
                                                {showApply && i == 3 && <div className={classes.point}></div>}
                                            </Grid>
                                        }
                                    />
                                ))
                            }
                        </BottomNavigation>
                    </AppBar>
                    {
                        dialogs.map((item, i) =>
                            (<item.dialogClass navigator={this} key={item.name + i} {...item.params} />)
                        )
                    }
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={snackopened}
                        onClose={() => this.setState({ snackopened: false })}
                        message={message}
                        autoHideDuration={3000}>
                    </Snackbar>
                </React.Fragment>
            );
        } else {
            return (<></>)
        }

    }
}

export default withStyles((theme) => ({
    appBarBottom: {
        top: 'auto',
        bottom: 0,
    },
    paperBottom: {
        backgroundColor: '#EFEFF4',
    },
    tabIcon: {
        width: 22,
        height: 22,
    },
    point: {
        position: 'absolute',
        right: 8,
        top: 0,
        backgroundColor: '#FF0000',
        width: 6,
        height: 6,
        borderRadius: 3,
        // marginLeft: 2
    }
}))(MainPage);
